import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { NumberInput } from '../../form/input/number/number-input';
import { RadioInput, RadioInputSize } from '../../form/input/radio/radio-input';
import { ItemPickerItemOptionQuantityInputType } from '../types/config/item-option-quantity-input-type';
export const ItemPickerItemOptionQuantityInput = observer(props => {
    const { className, type, children, value, onChangeValue, min, max, quantityInputType } = props;
    switch (type) {
        case ItemPickerItemOptionQuantityInputType.Radio:
            return (_jsx(RadioInput, Object.assign({ optionValue: 'quantity', value: !!value, onChangeValue: newValue => onChangeValue(newValue ? 1 : 0), labelClassName: className, size: RadioInputSize.Large }, { children: children })));
        case ItemPickerItemOptionQuantityInputType.Number:
        default:
            return (_jsxs("div", Object.assign({ className: className }, { children: [children, _jsx(NumberInput, { value: value, type: quantityInputType, min: min, max: max, disabled: max === 0, onChangeValue: onChangeValue })] })));
    }
});
ItemPickerItemOptionQuantityInput.displayName = 'ItemPickerItemOptionQuantityInput';
